export const getDefaultOptions = <TRequest>(id: number = 0, onTransmutation?: () => void) => ({
	requestType: 'transmutation',
	requestProps: { id: id > 0 ? id : 0 } as TRequest,
	onSuccess: id > 0
		? onTransmutation || (typeof window === 'undefined' ? () => undefined : window.location.reload.bind(window.location))
		: () => typeof window !== 'undefined' && window.location.assign('/'),
	onError: (err: string) => console.log(err),
});
